import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import CalendarioV2Service from '../../services/calendarioV2.service';

const SelectLugaresCalendar = ({id, value, onChange, isInvalid, isClearable, isMulti,disabled}) => {
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const actualizar = async() =>{
        await CalendarioV2Service.lugaresCalendar().then((resp)=>{
            setItems(resp)
        })
        .catch((err)=>{
            setItems([])
        })
    }

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(ev){
            onChange(ev);
        } else {
            onChange(null);
        }
    };

    useEffect(() => {
        if(items.length > 0){
            const newOptions = items?.map((item) => {
                return { ...item, value: item.id, label: item.nombre };
            });
            setOptions(newOptions);
        }else{
            setOptions([])
        }
    }, [items]);

    useEffect(() => {
        if( options.length > 0 ){
            if(typeof value === 'string' || typeof value === 'number'){
                setSelectedValue(
                    options.find((opt) => opt.value === Number(value))
                );
            }else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>{
                    const item = items.find(it=>it.id === va);
                    if(item){
                        return {
                            value:item.id,
                            label:item.nombre
                        };
                    }
                    return null
                }))
            }
        }
    }, [options,value])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    useEffect(() => {
        actualizar()
    }, [])
    return (
        <Select
            isDisabled={disabled}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isMulti={isMulti}
        />
    );
};

SelectLugaresCalendar.defaultProps = {
    isClearable: false
};

export default SelectLugaresCalendar

